package navigation.home.clients.allclients

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.client.domain.repository.ClientRepository
import com.essntl.features.client.ui.allclients.AllClientsEvent
import com.essntl.features.client.ui.allclients.AllClientsState
import com.essntl.features.client.ui.allclients.AllClientsViewModel

class AllClientsScreenModel(
    clientRepository: ClientRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<AllClientsState>(AllClientsState()) {
    private val allClientsViewModel =
        AllClientsViewModel(
            clientRepository = clientRepository,
            state = mutableState,
            scope = screenModelScope,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AllClientsEvent) {
        allClientsViewModel.onEvent(event)
    }
}
